/* eslint-disable */
import React, {
  Component,
  PropTypes,
} from 'react';
import { initTextEditor } from './summerNoteHelpers';
import './semantic-summernote.css'
import { withPreferences } from 'store/preferences/withPreferences'

class SummerNote extends Component {

  componentDidMount() {
    const { ...props } =  this.props;
    this.createSummerNote(props);
    this.handleChange(props.editorId);
  }

  componentWillReceiveProps(nextProps) {
    const { editorId } =  nextProps;
    if(this.props.editorId !== editorId){
      this.removeSummerNote(this.props.editorId);
      setTimeout(() => {
        this.createSummerNote(nextProps);
        this.handleChange(editorId);
      }, 50)
    }
  }

  componentWillUnmount() {
    const { editorId } = this.props;
    this.removeSummerNote(editorId)
  }

  removeSummerNote = (editorId) => {
    const textEditor = $(`#text-editor-${editorId}`);
    if(textEditor){
      textEditor.summernote('destroy');
    }
  };

  createSummerNote = ({ editorId, value }) => {
    if (editorId) {
      initTextEditor(`text-editor-${editorId}`, this.props.settings);
      const textEditor = $(`#text-editor-${editorId}`);
      const editorContent = value || '<p><br /></p>';
      textEditor.summernote('code', editorContent);
    }
  };

  handleChange = (editorId) => {
    const { onChange } = this.props;
    $(`#text-editor-${editorId}`).on(
      'summernote.change',
      (_, contents,) => {
        onChange(contents)
      }
    );
  };

  render() {
    const { editorId } = this.props;
    return (
      // dont forget to add bootstrap-iso before summernote
      <div className="bootstrap-iso">
        <div id={`text-editor-${editorId}`}/>
      </div>
    );
  }
}

SummerNote.propTypes = {
  editorId: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  settings: PropTypes.object,
};
SummerNote.defaultProps = {
  onChange: () => {},
  settings: {},
};
SummerNote.StoreEditor = withPreferences()(({
  preferences,
  ...props,
}) => {
  const fontFamilies = preferences.font.family.map(({ value }) => value)
  return (
    <SummerNote
      settings={{
        fontNames: fontFamilies,
        fontNamesIgnoreCheck: fontFamilies,
        toolbar: [
          ['fontfamily', ['fontname', fontFamilies]],
        ]
      }}
      {...props}
    />
  )
})

export default SummerNote;



// WEBPACK FOOTER //
// ./src/components/summernote/SummerNote.js